<template>
  <div style="min-width: 1024px">
    <el-row :gutter="20" style="font-size: large; line-height: 42px;text-align: center;">
      <el-col :span="4" style="margin-left: 10px">
        <el-select v-model="department_id" :placeholder="$t('ChanceBoard.department')" clearable style="width: 100%">
          <el-option v-for="item in departmentList" :key="item.value" :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </el-col>

      <el-col :span="4">
        <el-select v-model="user_id" :placeholder="$t('ChanceBoard.sales_user_id')" class="toolbar_item" clearable filterable style="width: 100%">
          <el-option v-for="item in departmentUserList" :key="item.value" :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </el-col>

      <el-button type="primary" style="margin-left: 20px;margin-top: 5px" @click="selectChance" :loading="loading">{{ $t('ChanceBoard.query') }}</el-button>
    </el-row>

    <el-row :gutter="0" style="font-size: large; line-height: 42px;text-align: center;flex: auto">
      <template v-for="sceneItem in sceneList"  >
        <el-col :span="2"  class="val2" @click="searchByScene(sceneItem.value)">{{ sceneItem.name }}</el-col>
        <el-col :span="2" class="val3" @click="searchByScene(sceneItem.value)">{{ sceneAmount[sceneItem.value] }}</el-col>
      </template>
    </el-row>

    <frame-query ref="frameQuery" componentParam="pay_receive_board_details"
                 :parent-data="{department_id:this.department_id,sales_user_id:this.user_id, scene_id:this.scene_id}"></frame-query>

  </div>
</template>

<script>

export default {
  name: "PayReceiveBoard",
  data() {
    return {
      msg: {},
      loading: false,
      user_id: '',
      department_id: '',
      scene_id: '',
      sceneList: [{"name": "一月内收款", "value": "not_overtime_lt30"},
        {"name": "超时一月内", "value": "out_overtime_lt30"},
        {"name": "超时三月内", "value": "out_overtime_lt90"},
        {"name": "超时三月以上", "value": "out_overtime_gt90"},
        {"name": "坏账", "value": "bad_end"}],
      departmentList: [],
      departmentUserList: [],
      sceneAmount: {}
    }
  },
  computed: {
    i18n() {
      return this.$store.state.core.i18n
    },
  },
  methods: {
    clearData() {
      this.sceneChance = []
    },
    searchByScene(currentSceneId) {
      this.scene_id = currentSceneId;
      this.$refs.frameQuery.search();
    },
    //获取默认销售
    getSalesUser() {
      this.$axios.post('pay/chanceBoard/getSalesUser', this.formData).then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message.error("获取失败");
        }
        this.user_id = res.data;
        this.selectChance()
      })
    },

    //查询按钮
    selectChance() {
      this.loading = true;
      if (this.department_id == "" && this.user_id == "") {
        this.loading = false;
        return this.$message.error("请选择部门或人员");
      }
      this.loading = true;
      this.getSceneAmount()
      this.$refs.frameQuery.search();
    },

    //获取部门
    getDepartmentList() {
      this.$http('sysDsService.getLeaderDepartments(sales)').then(data => {
        this.departmentList = data;
      })
    },
    //当前用户下的销售
    getDepartmentSalesList() {
      //获取里面的人
      this.$http('sysDsService.getSubUsers(sales)').then(data => {
        this.departmentUserList = data;
      })
    },

    //获取漏斗等级数据
    getSceneAmount() {
      let params = {sales_user_id: this.user_id, department_id: this.department_id};
      this.$http('payReceiveBoardService.getSceneAmount()', params, false).then(data => {
        this.loading = false
        //赋值
        this.sceneAmount = data
      }, errMsg => {
        this.loading = false
        return this.$refs.searchMessage.showError(errMsg)
      })
    }

  },
  created() {
    this.getDepartmentList()
    this.getDepartmentSalesList()
    //this.getSalesUser()
  },
}
</script>

<style lang="less" scoped>
.detail-show {
  margin-top: 10px;
  padding: 15px 30px 5px 5px;
  border: 1px solid #ddd;
  min-height: 450px;
  word-break: break-all;
}

.doc-list {
  width: 100%;
  border: 1px solid lightblue;
  min-height: 100px;
}

.sales_ld {
  background-image: url("../../../../public/tmp/ld03.png");
  background-size: 100% 100%;
  width: 360px;
  height: 280px;
  font-size: x-large;
}

.ld_title {
  position: relative;
  left: 130px;
  top: -40px;
}

.sales_ld .cnt_d {
  position: relative;
  left: 156px;
  top: 8px;
  color: white;
}

.sales_ld .cnt_c {
  position: relative;
  left: 156px;
  top: 15px;
  color: white;
}

.sales_ld .cnt_b {
  position: relative;
  left: 163px;
  top: 20px;
  color: white;
}

.sales_ld .cnt_a {
  position: relative;
  left: 163px;
  top: 22px;
  color: white;
}

.sales_ld .cnt_w {
  position: relative;
  left: 165px;
  top: 40px;
  color: gold;
}

.sales_ld .cnt_f {
  position: relative;
  left: 40px;
  top: 5px;
  color: red;
}

.wk {
  font-size: x-large;
  line-height: 42px;
  color: black;
}

.wk.title {
  //border-bottom: 2px solid #ddd;
  //margin-bottom: 10px;
}

.val {
  background-color: coral;
  font-size: 20px;
  color: #fff;
}

.val2 {
  margin-left: 20px;
  margin-top: 10px;
  background-color: skyblue;
  color: #fff;
}

.val3 {
  margin-right: 20px;
  margin-top: 10px;
  font-size: 20px;
  background-color: coral;
  color: #fff;
}

.val4 {
  margin-top: 10px;
  background-color: skyblue;
  color: #fff;
}

.val5 {
  margin-top: 10px;
  background-color: coral;
  color: #fff;
}

.funnel-box {
  font-size: x-large;
  padding: 0 30px;

  .title {
    text-align: center;
  }

  .funnel {
    background-image: url("../../../../public/tmp/ld03.png");
    background-size: 100% 100%;
    width: 360px;
    height: 280px;
    padding-top: 50px;
    text-align: center;
    color: white;

    .cnt {
      height: 42px;
      line-height: 42px;
    }

    .end {
      position: relative;
    }

    .cnt_f {
      position: absolute;
      color: red;
      left: 22px;
      top: 5px;
      width: 55px;
    }

    .cnt_w {
      position: absolute;
      left: 150px;
      color: orange;
      top: 5px;
      width: 65px;
    }
  }


}


</style>